<template>
  <b-container class="booking-failure">
    <b-row>
      <b-col cols="12" class="text-center">
        <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-center">
        <label class="confirm-message-label" v-html="$t('booking_failure.failure_msg')"
               v-if="!paymentRecord || paymentRecord.payment_method !== 'cyber_source'"></label>
        <label class="confirm-message-label"
               v-if="paymentRecord && paymentRecord.payment_method === 'cyber_source'">
          {{ paymentRecord.cyber_source_payment_records[0].reason_code === '150' ? 'Transaction unsuccessful. Please try again' : 'Transaction rejected. Please contact your bank' }}
        </label>
      </b-col>
    </b-row>
    <b-row v-if="paymentRecord">
      <b-col>
        <label>{{ $t('booking_failure.request_ref_no') }}: {{ paymentRecord.payment_method === 'cyber_source' ? paymentRecord.cyber_source_payment_records[0].request_ref_no : paymentRecord.union_pay_payment_records[0].order_id }}</label>
      </b-col>
    </b-row>
    <hr>
    <b-row class="mt-3">
      <b-col>
        <b-button variant="primary" size="lg" @click="next">{{ $t('finish') }}</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'
import {onMounted, ref} from "@vue/composition-api";

library.add(faExclamationTriangle);

export default {
  name: 'InvoicePayFailure',
  setup(props, {root}) {
    const paymentRecord = ref(null);
    const getPaymentRecord = function () {
      root.$callAPI('aafb/invoice/payment_record/', {invoice_id: root.$route.params.invoiceId}, (response) => {
        paymentRecord.value = response.body.record;
      })
    }

    const next = function () {
      root.$router.push({name: 'my-account', query: {t: 6}})
    }

    onMounted(() => {
      getPaymentRecord();
    });

    return {
      paymentRecord,
      next,
    }
  },
}
</script>

<style lang="less">
.booking-failure {
  padding: 30px;

  .fa-exclamation-triangle {
    font-size: 5em;
  }

  .confirm-message-label {
    text-align: left;
    line-height: 2.5em;
    font-size: 2em;
  }

  .booking-summary-title {
    text-align: left;
    font-size: 2.5em;
  }

  .countdown {
    text-align: right;
    font-size: 2.5em;
  }

  .booking-pfailure-form {
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 30px;
    font-size: 1.2em;

    .col-form-label {
      color: rgba(0, 0, 0, 0.5);
      text-align: left;
    }
  }

  .accept-tnc {
    text-align: left;
    padding: 30px;
    font-size: 1.2em;
  }
}

.countdown {
  text-align: right;
}
</style>
